<template>
  <login-page v-if="$route.params.action === 'login'" />
  <signup-page v-if="$route.params.action === 'signup'" />
</template>

<script>
import LoginPage from "./LoginPage.vue";
import SignupPage from "./SignupPage.vue";

// import { mapState } from "vuex";

export default {
  components: {
    LoginPage,
    SignupPage,
  },
  // computed: {
  //   ...mapState({
  //     userLoggedIn: (state) => state.auth.userLoggedIn,
  //   }),
  // },
  // watch: {
  //   userLoggedIn(value) {
  //     if (value) {
  //       this.$router.push("/");
  //     }
  //   },
  // },
  // mounted() {
  //   this.$router.push("/");
  // },
};
</script>

<style>
</style>